"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.baseStyle = void 0;
exports.baseStyle = {
  control: function control(provided, state) {
    var returnState = __assign(__assign({}, provided), {
      borderRadius: '0',
      outline: 0
    });
    if (state.isFocused) {
      returnState = Object.assign(returnState, {
        boxShadow: 'inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px #135d70',
        color: 'rgba(19,93,112)',
        transition: 'border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s'
      });
    }
    return returnState;
  },
  container: function container(provided, state) {
    return state.selectProps.isSearchable ? __assign(__assign({}, provided), {
      borderRadius: '0',
      height: '75px'
    }) : __assign(__assign({}, provided), {
      borderRadius: '0'
    });
  },
  group: function group(base) {
    return __assign(__assign({}, base), {
      paddingBottom: '0',
      marginBottom: '-2px'
    });
  },
  valueContainer: function valueContainer(base) {
    return __assign(__assign({}, base), {
      flexWrap: 'nowrap',
      padding: '0',
      margin: '0',
      marginLeft: '4px',
      overflow: 'hidden',
      position: 'relative',
      color: '#135d70'
    });
  },
  menu: function menu(base, state) {
    var isGroup = state.options.map(function (option) {
      return option.options;
    }).length;
    return __assign(__assign({}, base), {
      borderRadius: '0',
      paddingTop: isGroup ? '4px' : '12px',
      marginTop: state.selectProps.isSearchable ? '2px' : '-1px',
      marginLeft: '1px',
      width: 'calc(100% - 2px)'
    });
  },
  menuList: function menuList(base) {
    return __assign(__assign({}, base), {
      paddingTop: '0',
      paddingBottom: '0'
    });
  },
  dropdownIndicator: function dropdownIndicator(base) {
    return __assign(__assign({}, base), {
      float: 'right',
      color: '#135d70',
      cursor: 'pointer',
      fill: '#135d70'
    });
  },
  indicatorContainer: function indicatorContainer(base) {
    return __assign(__assign({}, base), {
      color: '#135d70',
      fill: '#135d70'
    });
  },
  indicatorSeparator: function indicatorSeparator(base) {
    return __assign(__assign({}, base), {
      background: 'transparent'
    });
  },
  multiValueLabel: function multiValueLabel(base) {
    return __assign(__assign({}, base), {
      background: 'white',
      border: '0',
      color: '#135d70',
      fontSize: '1em',
      margin: '2px',
      padding: '0',
      paddingLeft: '0',
      whiteSpace: 'nowrap',
      overflow: 'hidden'
    });
  },
  multiValue: function multiValue(base) {
    return __assign(__assign({}, base), {
      background: 'white',
      border: '0',
      margin: '0'
    });
  },
  groupHeading: function groupHeading(base) {
    return __assign(__assign({}, base), {
      background: '#ebebeb',
      color: 'black',
      fontWeight: '700'
    });
  },
  // custom component styles
  checkboxButton: {
    display: 'flex',
    justifyContent: 'flex-start',
    width: '100%',
    background: '#ebebeb',
    border: '0',
    marginTop: '-6px',
    padding: '8px 0 0 8px',
    color: 'black'
  },
  controlPlaceholder: {
    marginLeft: '6px'
  },
  controlInput: {
    margin: '0 5px',
    border: '2px solid #c7c7c7',
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '5px',
    paddingLeft: '5px'
  },
  controlInputIcon: {
    color: 'black',
    fontSize: '20px',
    margin: '6px'
  },
  controlValue: {
    display: 'flex',
    marginTop: '-2px',
    overflow: 'hidden',
    paddingLeft: '4px'
  },
  customMultiValueLabel: {
    marginLeft: '2px',
    marginTop: '3px'
  },
  dropdownControl: {
    width: '100%',
    paddingBottom: '5px'
  },
  dropdownControlValue: {
    display: 'flex',
    justifyContent: 'space-between',
    verticalAlign: 'text-top',
    width: '100%'
  },
  dropdownControlValueSeparated: {
    marginTop: '9px'
  },
  optionCheckbox: {
    color: '#135d70',
    height: '2em',
    display: 'flex',
    paddingLeft: '8px',
    border: '0',
    width: 'calc(100% - 8px)',
    backgroundColor: 'transparent'
  },
  optionCheckboxSelectAll: {
    color: '#135d70',
    height: '2em',
    display: 'flex',
    paddingLeft: '8px',
    border: '0',
    width: 'calc(100% - 8px)',
    backgroundColor: 'transparent'
  },
  styledOption: function styledOption(_a) {
    var isSelected = _a.isSelected,
      isFocused = _a.isFocused,
      group = _a.group;
    var activeBackground = {
      background: '#cff4fe'
    };
    var focusState = {
      background: '#f7fdff'
    };
    var groupStyle = {
      paddingLeft: '30px'
    };
    var base = {
      display: 'flex',
      cursor: 'pointer',
      paddingTop: '8px',
      height: '40px'
    };
    base = group ? Object.assign(base, groupStyle) : base;
    base = isFocused ? Object.assign(base, focusState) : base;
    base = isSelected ? Object.assign(base, activeBackground) : base;
    return base;
  }
};